<template>
  <div ref="chartRef" class="container"></div>
</template>

<script>
import echarts from "echarts";
import * as dataBuilder from '../../../data-builder/index'
export default {
  name: "de-bar",
  props: ["color", "data", "xAxis", "series"],
  created(){
    this.options = {
        color: ['blue', '#c23531','#2f4554', '#61a0a8', '#d48265', '#91c7ae','#749f83',  '#ca8622', '#bda29a','#6e7074', '#546570', '#c4ccd3'],
        xAxis: {
          type: "category",
          data: [],
          axisLabel:{
            color:"white"
          }
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: [],
            type: "bar",
          }
        ]
      }
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart(type) {
      this.chartIns = echarts.init(this.$refs["chartRef"]);
      this.chartIns.setOption(this.options);
      this.chartIns.setOption({color:[this.color]})
      this.resizeChart = this.chartIns.resize;
      this.update();
      this.chartIns.on('mouseover', 'series', (a)=>{
        this.$emit('hoverItem', a);
      });
    },
    update(){
      if(this.chartIns&&this.data){
      let xAxisData = [];
      if(this.xAxis.rowOrColumn==='row'){
        xAxisData = this.data[this.xAxis.index];
      }else{
        xAxisData = this.data.map(row=>row[this.xAxis.index]);
      }

      let seriesData = [];
      if(this.series.rowOrColumn==='row'){
        seriesData = this.series.indexs.map(i=>{
          return {data:this.data[i], type:'bar'}
        });
      }else{
        seriesData = this.series.indexs.map(i=>{
          return {data:this.data.map(row=>row[i]), type:'bar'};
        });
      }
      this.chartIns.setOption({
        xAxis:{
          data:xAxisData
        }})
      let opt = this.chartIns.getOption();
      opt.series = seriesData;
      this.chartIns.setOption(opt, true)
      }
    },

    fetchData(){
      return dataBuilder.fetch(this.dataConfig).then((data)=>{
        this.data = data;
        this.update();
      });
    },

    highlightItem(data){
      this.chartIns.dispatchAction({
        type: 'downplay'
      });
      this.chartIns.dispatchAction({
        type: 'highlight',
        seriesIndex: data.seriesIndex,
        dataIndex: data.dataIndex
      })
    }
  },
  watch: {
    color:{
      handler(color){
        if(this.chartIns){
          this.chartIns.setOption({color:[color]})
        }
      },
      immediate:true
    },

    xAxis:{
      handler(){
        this.update();
      },
      immediate:true
    },

    series:{
      handler(){
        this.update();
      },
      immediate:true
    },

    data:{
      handler(){
        this.update();
      },
      immediate:true
    },

    dataConfig:{
      handler(){
        if(this.dataConfig){
          this.fetchData()
        }
      },
      immediate:true
    }
  }
};
</script>

<style scoped>
@import url("~@/runtime-components/assets/common.css");
</style>